import {
  AutomationTrip,
  AutomationTripAssignmentReason,
  AutomationTripAssignmentReasonConnectionInput,
  AutomationTripConnectionInput,
  SearchTypeEnum,
} from '@/models/gen/graphql';
import {
  SearchAutomationTripAssignmentReasonDocument,
  SearchAutomationTripDocument,
  SearchAutomationTripPreviewDocument,
} from '@/api/queries';

import { Dayts } from '@/utils';
import graphApi from '@/api';

const [, runSearchAutomationTrip] = graphApi(SearchAutomationTripDocument);
const [, runSearchAutomationTripPreview] = graphApi(SearchAutomationTripPreviewDocument);
const [, runSearchAutomationTripAssignmentReason] = graphApi(SearchAutomationTripAssignmentReasonDocument);

const searchAutomationTrip = async (automationHistoryId: string): Promise<AutomationTrip[]> => {
  if (!automationHistoryId) throw new Error('Automation history ID cannot be empty.');
  const input: AutomationTripConnectionInput = {
    first: 1000,
    after: null,
    query: [
      {
        automationHistoryId: [
          {
            values: [automationHistoryId],
            type: SearchTypeEnum.Or,
          },
        ],
      },
    ],
  };

  const res = await runSearchAutomationTrip({ input });
  return res?.searchAutomationTrip?.automationTripConnection?.edges?.map((edge) => edge.node) ?? [];
};

export const searchAutomationTripPreview = async (from: string, to: string, market: string[]): Promise<AutomationTrip[]> => {
  const fromDate = new Dayts(from).utc().startOf('day').add(3, 'hours');
  const toDate = new Dayts(to)
    .utc()
    .startOf('day')
    .add(1, 'day')
    .add(2, 'hours')
    .add(59, 'minutes')
    .add(59, 'seconds')
    .add(999, 'milliseconds');
  if (toDate.diff(fromDate, 'days') > 3) {
    toDate
      .setDate(fromDate)
      .add(3, 'days')
      .startOf('day')
      .add(1, 'day')
      .add(2, 'hours')
      .add(59, 'minutes')
      .add(59, 'seconds')
      .add(999, 'milliseconds');
  }
  if (!market.length) throw new Error('Market cannot be empty.');
  const input: AutomationTripConnectionInput = {
    first: 1000,
    after: null,
    query: [
      {
        airportCode: [
          {
            values: market,
            type: SearchTypeEnum.Or,
          },
        ],
        scheduled: [
          {
            values: [fromDate.toISOString(), toDate.toISOString()],
            type: SearchTypeEnum.Range,
          },
        ],
      },
    ],
  };

  const res = await runSearchAutomationTripPreview({ input });
  return res?.searchAutomationTrip?.automationTripPreviewConnection?.edges?.map((edge) => edge.node) ?? [];
};

export const searchAutomationTripAssignmentReason = async (...id: string[]): Promise<AutomationTripAssignmentReason[]> => {
  if (!id.length) throw new Error('ID cannot be empty.');
  const input: AutomationTripAssignmentReasonConnectionInput = {
    first: 1000,
    after: null,
    query: [
      {
        automationTripId: [
          {
            values: id,
            type: SearchTypeEnum.Or,
          },
        ],
      },
    ],
  };

  const res = await runSearchAutomationTripAssignmentReason({ input });
  return res?.searchAutomationTrip?.automationTripAssignmentReasonConnection?.edges?.map((edge) => edge.node) ?? [];
};

export default searchAutomationTrip;
